import React from "react";
import { DataSection } from "../components";

const fields = [
  { key: "area", label: "Bereich", type: "text" },
  { key: "requirement", label: "Anforderung", type: "text" },
  { key: "status", label: "Status", type: "select", options: ["green", "amber", "red"], badge: true },
  { key: "note", label: "Bemerkung", type: "textarea" },
  { key: "last_reviewed", label: "Letzte Prüfung", type: "date" },
];

const Compliance = () => <DataSection overline="Governance" title="Compliance / IKS" entity="compliance" fields={fields} />;
export default Compliance;
